var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.baseUrl)?_c('documents',{attrs:{"base_url":_vm.baseUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }